import { render, staticRenderFns } from "./RegionView.vue?vue&type=template&id=70d28820&scoped=true&"
import script from "./RegionView.vue?vue&type=script&lang=js&"
export * from "./RegionView.vue?vue&type=script&lang=js&"
import style0 from "./RegionView.vue?vue&type=style&index=0&id=70d28820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d28820",
  null
  
)

export default component.exports